export default {
    data() {
        return {
            sortBy: null,
            sortOrder: 'descending',
            defaultSortBy: null,
            defaultSortOrder: 'descending',
            secondSortBy: null,
            secondSortOrder: 'descending',
            previousSort: {
                prop: null,
                order: null
            }
        }
    },

    methods: {
        sortColumn(a, b) {
            if (typeof a == 'string') return a.toLowerCase().localeCompare(b.toLowerCase(), 'en', { numeric: true })
            else return a - b
        },

        sortColumnBy(sortBy) {
            return (a, b) => this.sortColumn(a[sortBy], b[sortBy]) || this.secondSort(a, b)
        },

        secondSort(a, b) {
            if (this.secondSortBy && this.secondSortBy !== this.sortBy) {
                const [A, B] = this.secondSortOrder == this.sortOrder ? [a, b] : [b, a]
                return this.sortColumn(A[this.secondSortBy], B[this.secondSortBy])
            }
            return 0
        },

        handleSortChange({ prop, order, table }) {
            this.previousSort = { prop: this.sortBy, order: this.sortOrder }

            if (table) table.clearSort()

            if (this.defaultSortBy && (prop == null || order == null)) {
                this.sortBy = this.defaultSortBy
                this.sortOrder = this.defaultSortOrder
                table && table.sort(this.defaultSortBy, this.defaultSortOrder)
            } else {
                this.sortBy = prop
                this.sortOrder = order
                table && table.sort(prop, order)
            }
        },

        handleQueryReset(table) {
            if (this.sortBy == 'score') {
                this.handleSortChange({ ...this.previousSort, table })
            }
        }
    }
}
